import { Bot } from "lucide-react";

import type { TIconProps } from "./types";

export const Agents = (props: TIconProps): JSX.Element => (
  <Bot
    stroke="var(--fill1)"
    style={{ strokeWidth: "calc(1.5 + var(--nav-glyph-bold, 0) * 1.2)" }}
    {...props}
  />
);
